import React from 'react';
import { Chip } from '@mui/material';
import type { VisitStatus } from '@app-types/reception';
import {
  Schedule as ScheduledIcon,
  CheckCircle as ArrivedIcon,
  LocalHospital as ConsultationIcon,
  Done as FinishedIcon,
  Cancel as CanceledIcon,
  ErrorOutline as NoShowIcon
} from '@mui/icons-material';

interface VisitStatusBadgeProps {
  status: VisitStatus;
  size?: 'small' | 'medium';
}

const statusConfig = {
  scheduled: {
    label: 'Programat',
    color: 'info' as const,
    icon: ScheduledIcon
  },
  arrived: {
    label: 'Sosit',
    color: 'success' as const,
    icon: ArrivedIcon
  },
  in_consultation: {
    label: 'In consultatie',
    color: 'warning' as const,
    icon: ConsultationIcon
  },
  finished: {
    label: 'Finalizat',
    color: 'success' as const,
    icon: FinishedIcon
  },
  canceled: {
    label: 'Anulat',
    color: 'error' as const,
    icon: CanceledIcon
  },
  no_show: {
    label: 'Absent',
    color: 'error' as const,
    icon: NoShowIcon
  }
};

export const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status] || statusConfig.scheduled;
  const Icon = config.icon;

  return (
    <Chip
      icon={<Icon />}
      label={config.label}
      color={config.color}
      size={size}
      variant="filled"
    />
  );
};

